import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { PreferencesPage } from '@/features/preferences/preferences-page';
import { ConsoleShell } from '@/features/shell/console-shell';

/** Préférences (porting README #93) : entrée « Préférences » du menu utilisateur. */
export const Route = createFileRoute('/$tenant/preferences')({ component: PreferencesRoute });

function PreferencesRoute() {
  const { tenant } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell tenantId={tenant} crumbs={[{ label: t('preferences.title') }]}>
      <PreferencesPage />
    </ConsoleShell>
  );
}
